import { Projects } from '@/app/components/Projects';

export function ProjectsPage() {
  return <Projects />;
}
